import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    // 用catch捕获重复跳转的错误，避免控制台警告
    return originalPush.call(this, location).catch((err) => {
        // 只忽略"重复导航"的错误，其他错误正常抛出
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }
    })
}

function checkinGuard(to, from, next) {
    if (!localStorage.getItem('checkin_token')) {
        next({ path: '/checkin/login', query: { redirect: to.fullPath } })
        return
    }
    next()
}

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('../views/index.vue'),
    },
    { path: '/events', name: 'events', component: () => import('../views/events/index.vue') },
    { path: '/events/:id', name: 'event-detail', component: () => import('../views/events/detail.vue') },
    { path: '/events/:id/personal-entry', name: 'personal-entry', component: () => import('../views/apply/entry.vue'), props: { mode: 'PERSONAL' } },
    { path: '/events/:id/team-entry', name: 'team-entry', component: () => import('../views/apply/entry.vue'), props: { mode: 'TEAM' } },
    { path: '/events/:id/teams/create', name: 'team-create', component: () => import('../views/teams/create.vue') },
    { path: '/events/:id/teams/join', name: 'team-join', component: () => import('../views/teams/join.vue') },
    { path: '/events/:id/team-apply', name: 'team-apply', component: () => import('../views/teams/apply.vue') },
    { path: '/events/:id/apply', name: 'event-apply', component: () => import('../views/apply/index.vue') },
    { path: '/announcements', name: 'announcements', component: () => import('../views/announcements/index.vue') },
    { path: '/announcements/:id', name: 'announcement-detail', component: () => import('../views/announcements/detail.vue') },
    { path: '/help', name: 'help', component: () => import('../views/help/index.vue') },
    { path: '/help/:id', name: 'help-detail', component: () => import('../views/help/detail.vue') },
    { path: '/agreements', name: 'agreements', component: () => import('../views/agreements/index.vue') },
    { path: '/applications', name: 'applications', component: () => import('../views/member/applications.vue') },
    { path: '/applications/:id/change-request', name: 'application-change-request', component: () => import('../views/member/applicationChangeRequest.vue') },
    { path: '/applications/:id', name: 'application-detail', component: () => import('../views/member/applicationDetail.vue') },
    { path: '/teams', name: 'teams', component: () => import('../views/member/teams.vue') },
    { path: '/teams/:id', name: 'team-detail', component: () => import('../views/member/teamDetail.vue') },
    { path: '/results', name: 'results', component: () => import('../views/member/results.vue') },
    { path: '/results/:id', name: 'result-detail', component: () => import('../views/member/resultDetail.vue') },
    { path: '/notifications', name: 'notifications', component: () => import('../views/member/notifications.vue') },
    { path: '/notifications/:id', name: 'notification-detail', component: () => import('../views/member/notificationDetail.vue') },
    { path: '/profile', name: 'profile', component: () => import('../views/member/profile.vue') },
    { path: '/realname', name: 'realname', component: () => import('../views/member/realname.vue') },
    { path: '/profile/password', name: 'profile-password', component: () => import('../views/member/changePassword.vue') },
    { path: '/certificates/:id', name: 'certificate-detail', component: () => import('../views/member/certificateDetail.vue') },
    { path: '/certificate-verify', name: 'certificate-verify', component: () => import('../views/certificateVerify.vue') },
    {
        path: '/staff/login',
        name: 'staff-login',
        component: () => import('../views/staff/login.vue'),
        props: (route) => ({ redirect: route.query.redirect || '/staff/reviews' }),
    },
    {
        path: '/staff/reviews',
        name: 'staff-reviews',
        component: () => import('../views/staff/reviews.vue'),
        beforeEnter(to, from, next) {
            if (!localStorage.getItem('front_token')) {
                next({ path: '/staff/login', query: { redirect: to.fullPath } })
                return
            }
            next()
        },
    },
    {
        path: '/staff/reviews/:id',
        name: 'staff-review-detail',
        component: () => import('../views/staff/reviewDetail.vue'),
        beforeEnter(to, from, next) {
            if (!localStorage.getItem('front_token')) {
                next({ path: '/staff/login', query: { redirect: to.fullPath } })
                return
            }
            next()
        },
    },
    {
        path: '/staff/requests',
        name: 'staff-requests',
        component: () => import('../views/staff/requests.vue'),
        beforeEnter(to, from, next) {
            if (!localStorage.getItem('front_token')) {
                next({ path: '/staff/login', query: { redirect: to.fullPath } })
                return
            }
            next()
        },
    },
    {
        path: '/staff/requests/:id',
        name: 'staff-request-detail',
        component: () => import('../views/staff/reviewDetail.vue'),
        beforeEnter(to, from, next) {
            if (!localStorage.getItem('front_token')) {
                next({ path: '/staff/login', query: { redirect: to.fullPath } })
                return
            }
            next()
        },
    },
    {
        path: '/staff/notifications',
        name: 'staff-notifications',
        component: () => import('../views/staff/notifications.vue'),
        beforeEnter(to, from, next) {
            if (!localStorage.getItem('front_token')) {
                next({ path: '/staff/login', query: { redirect: to.fullPath } })
                return
            }
            next()
        },
    },
    {
        path: '/checkin/login',
        name: 'checkin-login',
        component: () => import('../views/checkin/login.vue'),
        props: (route) => ({ redirect: route.query.redirect || '/checkin/events' }),
    },
    { path: '/checkin/scan', name: 'checkin-global-scanner', component: () => import('../views/checkin/scanner.vue'), beforeEnter: checkinGuard },
    { path: '/checkin/events', name: 'checkin-events', component: () => import('../views/checkin/events.vue'), beforeEnter: checkinGuard },
    { path: '/checkin/events/:eventId', name: 'checkin-event-detail', component: () => import('../views/checkin/eventDetail.vue'), beforeEnter: checkinGuard },
    { path: '/checkin/events/:eventId/registrations/:id', name: 'checkin-registration-detail', component: () => import('../views/checkin/registrationDetail.vue'), beforeEnter: checkinGuard },
    { path: '/checkin/events/:eventId/scan', name: 'checkin-scanner', component: () => import('../views/checkin/scanner.vue'), beforeEnter: checkinGuard },
    { path: '/checkin/records', name: 'checkin-records', component: () => import('../views/checkin/records.vue'), beforeEnter: checkinGuard },
    { path: '/checkin/profile', name: 'checkin-profile', component: () => import('../views/checkin/profile.vue'), beforeEnter: checkinGuard },
    { path: '*', redirect: '/' },
]

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
})

export default router
